import { ITeplarFileListVM } from '../../models/response/ITeplarResponse';
const initialTeplarFilesState: ITeplarFileListVM = {
  S3Files: [],
  PagingDetail: {
    TotalRecords: 0,
    PageRecord: 0,
    ContinuationToken: ''
  }
};

export default initialTeplarFilesState;
